import Vue from "vue";
import vuetify from "./plugins/vuetify";
import VueTheMask from "vue-the-mask";

import App from "./App.vue";
import router from "./router";
import store from "./store";

import "@/styles/global.scss";

Vue.use(VueTheMask);

Vue.config.productionTip = false;

Vue.filter("phone", function (value) {
  if (!value) return "";
  value = value.toString();
  if (value.length === 10) {
    return `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6)}`;
  } else if (value.length === 7) {
    return `${value.slice(0, 3)}-${value.slice(3)}`;
  }
  return value;
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
